import { graphql } from 'react-relay';

export const bznavUserInfo = graphql`
  query userInfoQuery {
    bznavRefund {
      user {
        name
        phone
        birthDay
        indis {
          tin
        }
      }
    }
  }
`;
